export class FaqsPathNotImplementedError extends Error {
  static create(errorMessage) {
    return new FaqsPathNotImplementedError(errorMessage)
  }
}
